// extracted by mini-css-extract-plugin
module.exports = {"outer-wrapper":"_1WZqb","outerWrapper":"_1WZqb","wrapper":"_1c5OU"};